import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from "rxjs/Subscription";
import { NotificationsService } from "angular2-notifications";

import { GUID, Param } from "app/brightserve/brightserve.module";
import { IncidentAdvice, SlimScrollOptions } from "app/shared/shared.module";
import { AddonService } from "app/add-ons/addon.service";

@Component({
  selector: 'app-addon-incident-advice',
  templateUrl: './addon-incident-advice.component.html',
  styleUrls: ['./addon-incident-advice.component.css']
})
export class AddonIncidentAdviceComponent implements OnInit {

    Advice: IncidentAdvice[];
    IncidentAdd: boolean = false;
    IncidentAdviceText: string;

    GetIncidentAdviceSubscription: Subscription;
    AddIncidentAdviceSubscription: Subscription;

    SlimScrollOptions = SlimScrollOptions;

    @Input() IncidentId: GUID;
    @Input() EnableAdd: boolean = false;

    constructor(private addonService: AddonService, private _notification: NotificationsService) { }


    ngOnInit() {
        this.Reset();
    }

    ngOnChanges() {
        this.GetIncidentAdvice();
    }

    ngOnDestroy() {
        if (this.GetIncidentAdviceSubscription != null)
            this.GetIncidentAdviceSubscription.unsubscribe();
        if (this.AddIncidentAdviceSubscription != null)
            this.AddIncidentAdviceSubscription.unsubscribe();
    }

    OpenAdd() {
        this.IncidentAdd = true;
    }

    GetIncidentAdvice() {
        if (this.IncidentId) {
            this.GetIncidentAdviceSubscription = this.addonService.GetIncidentAdvice(this.IncidentId).subscribe(
                advice => {
                    this.Advice = advice;
                }, err => {
                    this._notification.error("Data Error", "Incident advice data for this incident could not be obtained.");
                }
            );
        }
    };

    AddIncidentAdvice() {
        var advice = IncidentAdvice.BlankIncidentAdvice();
        advice.Text = this.IncidentAdviceText;
        advice.Status = new Param({ Entity: "Annotation", Field: "Status", Value: "New" });
        this.AddIncidentAdviceSubscription = this.addonService.AddIncidentAdviceToIncident(this.IncidentId, advice).subscribe(
            finding => {
                this.Reset();
                this.GetIncidentAdvice();
                this._notification.success("Advice Saved", "Incident advice was added to this incident successfully.");
            }, err => {
                this._notification.error("Advice not Saved", "Incident advice was not added to this incident successfully.");
            }
        );
    }

    Reset() {
        this.IncidentAdd = false;
        this.IncidentAdviceText = "";
    }
}



// WEBPACK FOOTER //
// ./src/app/add-ons/incident-advice/addon-incident-advice.component.ts